import {Grey17, Grey6} from "../../theme/styles";
import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {IconButton, Chip, Menu, MenuItem, Typography, Tooltip} from "@mui/material";
import css_buttons from "../../components/Common/css/CCButton.module.scss";
import css_self from "../Navigation/css/NavBar.module.scss";
import React from "react";
import EventBus from "../../util/EventBus";
import {ControlPoint, DeleteForever, Edit, Info, MoreVert, Refresh} from "@mui/icons-material";
import {hasPrivilege} from "../../util/SessionContext";
import ProjectPlanPhaseReferenceFormApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseReferenceFormApplet";
import css_link from "../Common/css/Link.module.scss";
import {PlatformTableTree} from "../PlatformTableTree";

class ProjectPlanPhaseReferenceTable extends PlatformTableTree {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("project-plan-phase-reference-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("project-plan-phase-reference-form-applet-save", this.onCancelHandler);
    };

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("project-plan-phase-reference-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("project-plan-phase-reference-form-applet-save", this.onCancelHandler);
    };

    getCellRenderer(name) {
        if (name === "State Cell") {
            return this.renderStateCell;
        } else if (name === "Status Cell") {
            return this.renderStatusCell;
        } else if (name === "Action Cell") {
            return this.renderActionCell;
        } else if (name === "Milestone Name Hyperlink Cell") {
            return this.renderMilestoneNameHyperlinkCell;
        } else if (name === "Reference Type Hyperlink Cell") {
            return this.renderReferenceTypeHyperlinkCell;
        } else if (name === "Name Hyperlink Cell") {
            return this.renderNameHyperlinkCell;
        } else if (name === "Approval Request Hyperlink Cell") {
            return this.renderApprovalRequestHyperLinkCell;
        }

        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "Add Reference") {
            this.setState({renderTarget: "Add Reference"});
        }
        super.handleMenuClick(identifier);
    }

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderExtension() {
        if (this.state.renderTarget === "Add Reference") {
            return <ProjectPlanPhaseReferenceFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="New"/>;
        }
        if (this.state.renderTarget === "Edit Reference") {
            return <ProjectPlanPhaseReferenceFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Edit"/>;
        }
        if (this.state.renderTarget === "Delete Reference") {
            return <ProjectPlanPhaseReferenceFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Delete"/>;
        }
    };

    renderStateCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let backgroundColor;
        let content;
        if (this.state.buffer[params.row.id].get("DisplayStatus") === "Draft" || this.state.buffer[params.row.id].get("DisplayStatus") === "Last Signed" || this.state.buffer[params.row.id].get("DisplayStatus") === "WIP") {
            backgroundColor = "#DCF4FD";
            content = <Chip id="1" label={this.state.buffer[params.row.id].get("DisplayStatus")} size="small" style={{border: "1px solid #457AB5", minWidth: "100px", fontSize: 12, backgroundColor: backgroundColor, color: "#457AB5", paddingTop: "1px", marginTop: "auto", marginBottom: "auto"}}/>
        } else if (this.state.buffer[params.row.id].get("DisplayStatus") === "Pending Change" || this.state.buffer[params.row.id].get("DisplayStatus") === "Pending Approval" || this.state.buffer[params.row.id].get("DisplayStatus") === "In Review") {
            backgroundColor = "#FEF8EE";
            content = <Chip id="1" label={this.state.buffer[params.row.id].get("DisplayStatus")} size="small" style={{border: "1px solid #B25F00", minWidth: "100px", fontSize: 12, backgroundColor: backgroundColor, color: "#B25F00", paddingTop: "1px", marginTop: "auto", marginBottom: "auto"}}/>
        } else if (this.state.buffer[params.row.id].get("DisplayStatus") === "Released" || this.state.buffer[params.row.id].get("DisplayStatus") === "Approved") {
            backgroundColor = "#E6FCD9"
            content = <Chip id="2" label={this.state.buffer[params.row.id].get("DisplayStatus")} size="small" style={{border: "1px solid #509849", minWidth: "100px", fontSize: 12, backgroundColor: backgroundColor, color: "#509849", paddingTop: "1px", marginTop: "auto", marginBottom: "auto"}}/>
        } else {
            content = <Typography style={{marginTop: "10px"}}>{this.state.buffer[params.row.id].get("DisplayStatus")}</Typography>
        }
        return (
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "100%"}}>
                {content}
            </div>
        );
    };

    renderStatusCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let status;

        if (this.state.buffer[params.row.id].get("DocumentTypeGroup") === "PO") {
            status = this.state.buffer[params.row.id].get("PurchaseOrderStatus");
        } else if (this.state.buffer[params.row.id].get("DocumentTypeGroup") === "LOT") {
            status = this.state.buffer[params.row.id].get("LotStatus");
        } else if (this.state.buffer[params.row.id].get("DocumentTypeGroup") === "EQUIPMENT") {
            status = this.state.buffer[params.row.id].get("EquipmentStatus");
        } else {
            status = "--";
        }
        return (
            <div>
                <Typography style={{fontSize: "14px", marginTop: "7px"}}>{status}</Typography>
            </div>
        );
    };

    renderApprovalRequestHyperLinkCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let link;
        if (process.env.REACT_APP_CRES_ENV === "prod") {
            link = "https://cres-intelligence.io/change_request/" + this.state.buffer[params.row.id].get("ApprovalRequestUSID") + "/preview"
        } else {
            link = "https://" + process.env.REACT_APP_CRES_ENV + ".cres-intelligence.io/change_request/" + this.state.buffer[params.row.id].get("ApprovalRequestUSID") + "/preview"
        }

        return (
            <div>
                <Typography style={{fontSize: "14px", marginTop: "10px"}}><a className={css_link.link} href={link} rel="noreferrer" target="_blank">{this.state.buffer[params.row.id].get("ApprovalRequestID")}</a></Typography>
            </div>
        );
    };

    renderMilestoneNameHyperlinkCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let link;
        if (process.env.REACT_APP_CRES_ENV === "prod") {
            link = "https://cres-intelligence.io/document_revision/" + this.state.buffer[params.row.id].get("DocumentUSID") + "/version/" + this.state.buffer[params.row.id].get("DocumentRevisionUSID")
        } else {
            link = "https://" + process.env.REACT_APP_CRES_ENV + ".cres-intelligence.io/document_revision/" + this.state.buffer[params.row.id].get("DocumentUSID") + "/version/" + this.state.buffer[params.row.id].get("DocumentRevisionUSID")
        }

        return (
            <div>
                <Typography style={{marginTop: "7px"}}><a className={css_link.link} href={link} rel="noreferrer" target="_blank">{this.state.buffer[params.row.id].get("MilestoneName")}</a></Typography>
            </div>
        );
    };

    renderNameHyperlinkCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let link;
        if (process.env.REACT_APP_CRES_ENV === "prod") {
            link = "https://cres-intelligence.io/document_revision/" + this.state.buffer[params.row.id].get("DocumentUSID") + "/version/" + this.state.buffer[params.row.id].get("DocumentRevisionUSID")
        } else {
            link = "https://" + process.env.REACT_APP_CRES_ENV + ".cres-intelligence.io/document_revision/" + this.state.buffer[params.row.id].get("DocumentUSID") + "/version/" + this.state.buffer[params.row.id].get("DocumentRevisionUSID")
        }

        return (
            <div>
                <Typography style={{marginTop: "7px"}}><a className={css_link.link} href={link} rel="noreferrer" target="_blank">{this.state.buffer[params.row.id].get("Name")}</a></Typography>
            </div>
        );
    };

    renderReferenceTypeHyperlinkCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let link;
        if (process.env.REACT_APP_CRES_ENV === "prod") {
            link = "https://cres-intelligence.io/document_revision/" + this.state.buffer[params.row.id].get("DocumentUSID") + "/version/" + this.state.buffer[params.row.id].get("DocumentRevisionUSID")
        } else {
            link = "https://" + process.env.REACT_APP_CRES_ENV + ".cres-intelligence.io/document_revision/" + this.state.buffer[params.row.id].get("DocumentUSID") + "/version/" + this.state.buffer[params.row.id].get("DocumentRevisionUSID")
        }

        return (
            <div>
                <Typography style={{marginTop: "7px"}}><a className={css_link.link} href={link} rel="noreferrer" target="_blank">{this.state.buffer[params.row.id].get("ReferenceType")}</a></Typography>
            </div>
        );
    };

    deriveAddReferenceTooltip() {
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE") {
            return "This feature is not available because the status of the phase is 'DONE'"
        }
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "IN REVIEW") {
            return "This feature is not available because the status of the phase is 'IN REVIEW'"
        }
        if (hasPrivilege("Add Milestone Reference") === false) {
            return "This feature is disabled because you do not have the 'Add Milestone Reference' privilege in any of your assigned roles."
        }
    }

    renderMenuContent() {
        let menuItems = [];

        menuItems.push(
            <MenuItem key={"menuItem1"} onClick={(e) => {
                if (hasPrivilege("Add Milestone Reference") && this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") !== "DONE") {
                    e.stopPropagation();
                    this.handleMenuClick("Add Reference");
                    this.setState({showMenu: false});
                } else {
                    // do nothing
                }
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <ControlPoint sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Add Reference
                {!hasPrivilege("Add Milestone Reference") ||
                    this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE"? (
                    <div style={{marginLeft: "10px", marginTop: "6px"}}>
                        <Tooltip title={this.deriveAddReferenceTooltip()}>
                            <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                        </Tooltip>
                    </div>
                ) : null}
            </MenuItem>
        );
        menuItems.push(
            <MenuItem key={"menuItem2"} onClick={(e) => {
                e.stopPropagation();
                this.handleMenuClick("Refresh");
                this.setState({showMenu: false});
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <Refresh sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Refresh
            </MenuItem>
        );

        return menuItems;
    };

    getPhaseMilestoneReferenceEditMilestoneTooltip() {
        if (this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") === "DONE") {
            return "This feature is disabled because the status of the Phase is 'DONE'.";
        }
        if (this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") === "DONE") {
            return "This feature is disabled because the status of the Milestone is 'DONE'.";
        }
        if (!hasPrivilege("Edit Milestone Reference")) {
            return "This feature is disabled because you do not have the 'Edit Milestone Reference' privilege in any of your assigned roles."
        }
    }

    getPhaseMilestoneReferenceDeleteMilestoneTooltip() {
        if (this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") === "DONE") {
            return "This feature is disabled because the status of the Phase is 'DONE'.";
        }
        if (this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") === "DONE") {
            return "This feature is disabled because the status of the Milestone is 'DONE'.";
        }
        if (!hasPrivilege("Delete Milestone Reference")) {
            return "This feature is disabled because you do not have the 'Delete Milestone Reference' privilege in any of your assigned roles."
        }
    }

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-10px"}}>
                <IconButton className={css_buttons.tableOptionButton} disableRipple sx={{"&:hover": {backgroundColor: "transparent"}}} onMouseDown={(event) => event.stopPropagation()} onClick={(event) => { event.stopPropagation();
                    this.applet.getEnterpriseComponent().selectRecord(params.row.id); this.setState({actionMenuAnchor: event.currentTarget, actionMenuRowId: params.row.id});
                }}>
                    <MoreVert sx={{fontSize: "1.35rem", position: "relative", top: "-1px"}} />
                </IconButton>
                <Menu
                    anchorEl={this.state.actionMenuAnchor}
                    anchorOrigin={{vertical: "center", horizontal: "right"}}
                    transformOrigin={{vertical: "top", horizontal: "left"}}
                    open={this.state.actionMenuRowId === params.row.id && !!this.state.actionMenuAnchor}
                    onClose={() => this.setState({actionMenuAnchor: null, actionMenuRowId: null})}
                    slotProps={{
                        paper: {elevation: 0, sx: {boxShadow: "none", borderRadius: 0, border: "1px solid #A8A9AF"}},
                        list: {...{"data-cc-component": "NavMenu"}, disablePadding: true, sx: {minWidth: "200px", "& .MuiMenuItem-root": {minHeight: "33px", height: "33px"}}},
                        transition: {onExited: () => this.setState({actionMenuAnchor: null, actionMenuRowId: null})},
                    }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        if (hasPrivilege("Edit Milestone Reference") && this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") !== "DONE" && this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") !== "DONE") {
                            this.applet.getEnterpriseComponent().selectRecord(params.row.id); this.setState({actionMenuAnchor: null, actionMenuRowId: null, renderTarget: "Edit Reference"});
                        }
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Edit Reference</Typography>
                        {!hasPrivilege("Edit Milestone Reference") ||
                        this.state.buffer[params.row.id].get("MilestoneStatus") === "DONE" ||
                        this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") === "DONE" ? (
                            <div style={{marginTop: "6px"}}>
                                <Tooltip title={this.getPhaseMilestoneReferenceEditMilestoneTooltip()}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}
                    </MenuItem>
                    <MenuItem divider key={"2"} className={css_self.Standard} onClick={() => {
                        if (hasPrivilege("Delete Milestone Reference") && this.applet.getEnterpriseComponent().getAttributeValue("MilestoneStatus") !== "DONE" && this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") !== "DONE") {
                            this.applet.getEnterpriseComponent().selectRecord(params.row.id); this.setState({actionMenuAnchor: null, actionMenuRowId: null, renderTarget: "Delete Reference"});
                        }
                    }}>
                        <DeleteForever style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Delete Reference</Typography>
                        {!hasPrivilege("Delete Milestone Reference") ||
                        this.state.buffer[params.row.id].get("MilestoneStatus") === "DONE" ||
                        this.applet.getEnterpriseComponent().getAttributeValue("PhaseStatus") === "DONE" ? (
                            <div style={{marginTop: "6px"}}>
                                <Tooltip title={this.getPhaseMilestoneReferenceDeleteMilestoneTooltip()}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}
                    </MenuItem>
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(ProjectPlanPhaseReferenceTable)));